import { APIClient } from "api/api_helper";
import { DESIGN_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const designApiService = {
    insertData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            designtitle: payload_data.designtitle,
            sequencetype: payload_data.sequencetype,
            period: payload_data.period,
            numberofsequences: payload_data.numberofsequences,
            numberoftreatments: payload_data.numberoftreatments,
            blocksize:payload_data.blocksize,
            createdby: user.userid,
        };

        return api.create(DESIGN_API.DESIGN_API + "Insert", payload);
    },
    updateData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studydesignid: payload_data.studydesignid,
            designtitle: payload_data.designtitle,
            sequencetype: payload_data.sequencetype,
            period: payload_data.period,
            numberofsequences: payload_data.numberofsequences,
            numberoftreatments: payload_data.numberoftreatments,
            updatereason: payload_data.updatereason,
            updatedby: user.userid,
            blocksize:payload_data.blocksize,
        };

        return api.create(DESIGN_API.DESIGN_API + "Update", payload);
    },
    deleteData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studydesignid: payload_data.studydesignid,
            updatereason: payload_data.updatereason,
            updatedby: user.userid,
        };

        return api.create(DESIGN_API.DESIGN_API + "Delete", payload);
    },
    selectAllData: (searchtext?: string | null, currentpage: number = 1, pagesize: number = 10) => {
        const payload = {
            searchtext: searchtext || "",
            currentpage: currentpage,
            pagesize: pagesize,
        };
        return api.create(DESIGN_API.DESIGN_API + "SelectAll", payload);
    },
};
